import { render, staticRenderFns } from "./UnidadMedidaCrear.vue?vue&type=template&id=452290de"
import script from "./UnidadMedidaCrear.vue?vue&type=script&lang=js"
export * from "./UnidadMedidaCrear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports